export enum MutationTypes {
    RESET = 'RESET',
    LOAD = 'LOAD',
    SET_DRAWED = 'SET_DRAWED',
    CHANGE_GROUPING_STRATEGY = 'CHANGE_GROUPING_STRATEGY',
    CHANGE_ODDS_STRATEGY = 'CHANGE_ODDS_STRATEGY',
}
